import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          <p>&copy; 2026 MoveLand. Alle Rechte vorbehalten.</p>
        </div>
      </div>  
    </footer>
  );
}

export default Footer;

